import React from 'react';
import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { VehiclePreloader } from 'site-modules/shared/utils/core-page/vehicle-preloader-v2';
import { getQuery } from 'client/utils/location';
import { setCriticalCss } from 'client/actions/critical-css';
import { getUnifiedLeadFormDealerCountV2Path, UnifiedLeadFormModel } from 'client/data/models/unified-lead-form';
import {
  buildModelsPath,
  buildMakeModelYearsPath,
  buildStylesPath,
  VehicleModel,
  buildNewTmvPricingPath,
} from 'client/data/models/vehicle-v2';
import { buildStyleBasicPathFromVinDecoder, VehicleVinModel } from 'client/data/models/vehicle-vin';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { NEW_CORE_LEAD_SUBMITTER } from 'site-modules/shared/constants/price-checker';
import { LEAD_FORM_CONFIGS } from 'site-modules/shared/constants/lead-form/lead-form-configs';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { PriceCheckerPage } from './price-checker-page';

export const PageDefinitionConfiguration = {
  name: 'price_checker',
  category: 'price_checker',
  preload: (store, props) => {
    const params = props.match.params;
    const query = getQuery(get(props, 'location', {}));
    const preloader = params.make ? new VehiclePreloader(store, { ...props, params }) : new ModelPreloader(store);

    const { make, model, year, vin } = { ...params, ...query };

    preloader.resolve('makesList', VehicleModel);

    return preloader.load().then(async () => {
      if (make) {
        preloader.resolve(buildModelsPath({ make }), VehicleModel);
      }

      if (make && model) {
        preloader.resolve(buildMakeModelYearsPath({ make, model }), VehicleModel);
      }

      if (make && model && year) {
        preloader.resolve(buildStylesPath({ make, model, year }), VehicleModel);
      }

      if (vin) {
        preloader.resolve(buildStyleBasicPathFromVinDecoder({ vin }), VehicleVinModel);
      }

      const hasMmy = !!(make && model && year);
      let hasDealerCount;

      if (hasMmy) {
        let modelState = await preloader.load();

        const currentStyleId =
          query.styleId || get(modelState.get(buildStylesPath({ make, model, year }), VehicleModel), '[0].id');

        preloader.resolve(buildNewTmvPricingPath(currentStyleId), VehicleModel);

        preloader.resolve(
          getUnifiedLeadFormDealerCountV2Path({
            makeSlug: make,
            modelSlug: model,
            strategy: LEAD_FORM_CONFIGS.QUICK_QUOTES_TRIM_DST.strategy,
          }),
          UnifiedLeadFormModel
        );

        modelState = await preloader.load();

        hasDealerCount = !!modelState.get(
          getUnifiedLeadFormDealerCountV2Path({
            makeSlug: make,
            modelSlug: model,
            strategy: LEAD_FORM_CONFIGS.QUICK_QUOTES_TRIM_DST.strategy,
          }),
          UnifiedLeadFormModel
        );
      }

      store.dispatch(
        setCriticalCss({
          hasMmy,
          hasVin: !!vin,
          hasPricingDrawer: !!hasDealerCount && query.utm_content === NEW_CORE_LEAD_SUBMITTER,
        })
      );

      return preloader.load();
    });
  },
  seo: {
    robots: {
      noFollow: true,
      noIndex: true,
    },
  },
  component: props => <PriceCheckerPage {...props} params={props.match.params} />,
  decorator: EdmundsCpaNoAdhesionDecorator,
};

export default pageDefinition(PageDefinitionConfiguration);
